import {Menu} from "@mantine/core";
import {useTranslation} from "react-i18next";
import {OperatingAreaEntity} from "@ots-frontend/ots-data";
import {useCallback, useMemo} from "react";
import {useAuth} from "../../../providers/AuthProvider/AuthProvider";
import {IconEdit, IconTrash} from "@tabler/icons-react";
import {useOperatingAreaAction} from "./useOperatingAreaAction";

const ALL_CONTAINER_CLUSTER_ACTIONS = [
  "EDIT",
  "DELETE",
] as const;

export type OperatingAreaAction = typeof ALL_CONTAINER_CLUSTER_ACTIONS[number];

export type OperatingAreaActionMenuDropdownProps = {
  operatingArea: OperatingAreaEntity
  actions?: OperatingAreaAction[]
  onActionClick?: (action: OperatingAreaAction) => void
  showEmpty?: boolean
}

export const OperatingAreaActionMenuDropdown = (props: OperatingAreaActionMenuDropdownProps) => {
  const {
    operatingArea,
    actions = ALL_CONTAINER_CLUSTER_ACTIONS,
    onActionClick,
    showEmpty = true
  } = props

  const {hasAccess} = useAuth()
  const {t} = useTranslation(["common"])

  const visibleActions: Set<OperatingAreaAction> = useMemo(() => {
    const enabledActions = new Set<OperatingAreaAction>()
    const actionsSet = actions ? new Set<OperatingAreaAction>(actions) : new Set<OperatingAreaAction>()

    if (false) {
      if (hasAccess("operatingarea_edit")) {
        if (actionsSet.has("EDIT")) {
          enabledActions.add("EDIT")
        }
      }
    }

    if (hasAccess("operatingarea_delete")) {
      if (actionsSet.has("DELETE")) {
        enabledActions.add("DELETE")
      }
    }

    return enabledActions
  }, [operatingArea, actions, hasAccess])

  const {
    onOperatingAreaActionClick
  } = useOperatingAreaAction()

  const _onActionClick = useCallback((action: OperatingAreaAction) => {
    if (onActionClick) {
      onActionClick(action)
    } else {
      onOperatingAreaActionClick(operatingArea, action)
    }
  }, [onActionClick, onOperatingAreaActionClick, operatingArea])

  return (
    <>
      {(showEmpty && visibleActions.size === 0) &&
        <Menu.Item>
          {t("common.action.none", "No Actions")}
        </Menu.Item>
      }
      {visibleActions.has("EDIT") &&
        <Menu.Item icon={<IconEdit size={14}/>} onClick={() => _onActionClick("EDIT")}>
          {t("common.action.edit", "Edit")}
        </Menu.Item>
      }
      {visibleActions.has("DELETE") &&
        <>
          {visibleActions.size > 1 && <Menu.Divider/>}
          <Menu.Item
            onClick={() => _onActionClick("DELETE")}
            icon={<IconTrash size={14}/>}
            color="red">
            {t("common.action.delete", "Delete")}
          </Menu.Item>
        </>
      }
    </>
  )
}
